<div class="google-review">
  <div class="header">
    <img src="../../../assets/img/google-logo.svg" alt="Google" class="google-logo">
    <div class="stars">
      <mat-icon>star</mat-icon>
      <mat-icon>star</mat-icon>
      <mat-icon>star</mat-icon>
      <mat-icon>star</mat-icon>
      <mat-icon>star</mat-icon>
    </div>
  </div>
  <div class="content">
    <p>{{ 'googleReview.question' | translate }}</p>
    <p>{{ 'googleReview.callToAction' | translate }}</p>
    <a href="https://g.page/r/CcXPh8kzljlpEBM/review" target="_blank" rel="noopener noreferrer">
      {{ 'googleReview.button' | translate }}
    </a>
  </div>
</div>
